import {
    VStack,
    Button,
} from '@chakra-ui/react';
import { FaIcon, NonIdealState } from '@acp/core-ui';
import { faExclamationCircle, IconDefinition } from '@fortawesome/pro-light-svg-icons';

function ExceptionHandlingReportedFinding({
    title,
    description,
    onClose,
    icon = faExclamationCircle,
}: {
    title: string;
    description: string;
    onClose: () => void;
    icon?: IconDefinition;
}) {
    return (
        <VStack minH="96" justifyContent="center">
            <NonIdealState
                iconComponent={<FaIcon w={12} h={12} icon={icon} color="danger.500" />}
                title={title}
                description={description}
                titleFontSize="lg"
            >
                <Button
                    colorScheme="blackAlpha"
                    bgColor="black"
                    size="md"
                    onClick={onClose}
                >
                    Close
                </Button>
            </NonIdealState>
        </VStack>
    );
}

export { ExceptionHandlingReportedFinding };
